module.exports = "/assets/1d226613737bb763c12696741723a1bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XK.png
// module id = 1999
// module chunks = 0